import { UpperCasePipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core'
import { Title } from '@angular/platform-browser'
import { RouterOutlet } from '@angular/router'

import { HlmToaster } from '@yoshu-lib/ui/sonner/src'

import { environment } from '../environments/environment'

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, HlmToaster, UpperCasePipe],
  template: `
    @if (currentEnvironment === 'development' || currentEnvironment === 'staging') {
      <div
        class="flex h-8 items-center justify-center border-b border-black/5 bg-yellow-100 bg-[length:0.8rem_0.8rem] px-3 text-center text-sm font-semibold text-yellow-800 [background-image:linear-gradient(45deg,rgba(0,0,0,0.03)_25%,transparent_25%,transparent_50%,rgba(0,0,0,0.03)_50%,rgba(0,0,0,0.03)_75%,transparent_75%,transparent)]"
      >
        {{ currentEnvironment | uppercase }}
      </div>
    }

    <router-outlet></router-outlet>
    <hlm-toaster [richColors]="true" />
  `,
  styles: `
    :host {
      display: flex;
      flex-direction: column;
      height: 100dvh;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit {
  private readonly titleService = inject(Title)
  readonly currentEnvironment = environment.name

  ngOnInit() {
    if (this.currentEnvironment !== 'production') {
      const title = this.titleService.getTitle()
      this.titleService.setTitle(`[${this.currentEnvironment.toUpperCase()}] - ${title}`)
      document.body.classList.add('has-env-banner')
    }
  }
}
